import { useEffect, useRef, useState } from "react";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import { checkUserAccess } from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import { Nav, NavItem, NavLink, TabContent, Fade, TabPane } from "reactstrap";
import AddLeaveModal from "../Leave/AddLeaveModal";
import {
  updateDateFilter,
  updateFiltersStates,
} from "../../../store/actions/UserActions";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import AttendanceTable from "./AttendanceTable";
import EditIcon from "../../../components/Icons/EditIcon";
import FullPageLoaderMarkAtt from "../../../components/Loaders/FullPageLoaderMarkAtt";
import AddBulkAttModal from "./AddBulkAttModal";
import PlusIcon from "../../../components/Icons/PlusIcon";


export default function ManageBulkAtt() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const dateFilter = useSelector((state) => state.root.months);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [selectedLeaveDate, setSelectedLeaveDate] = useState(null);
  const [state, setState] = useState({
    officeList: null,
    userList: null,
    attendanceList: [],
    isAttendanceMarkLoading: false,
  });
  const [pageStates, setPageStates] = useState({
    activeTab: 1,
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    count: 0,
    ...(checkUserAccess(userDetails).isUserAccess
      ? { staffType: "1" }
      : { staffType: "0" }),
    searchQuery: "",
    tableLoader: false,
    attendanceStatus: "",
    attendanceType: "",
    sortByDate: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
    siteId: filterDetails?.siteId,
    officeName: "",
    user: "",
    officeType: "",
    companyList: [],
    siteList: [],
    companyId: "",
    userName: "",
    companyIsLoading: false,
    isInitial: true,
    isLoadingSite: false,
  });
  const [modal, setModal] = useState(false);
  const [bulkAttModal, setBulkAttModal] = useState({ isOpen: false, user: null });
  const timeoutId = useRef(null);


  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleTab = (tab) => {
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        staffType: "1",
        activeTab: tab,
        siteId: "",
        currentPage: 1,
      }));
      dispatch(
        updateFiltersStates({
          companyId: "",
        }),
      );
    } else {
      setPageStates((prev) => ({
        ...prev,
        staffType: "0",
        activeTab: tab,
        siteId: filterDetails?.siteId,
        currentPage: 1,
      }));
      dispatch(
        updateFiltersStates({
          companyId: "",
        }),
      );
      getSite();
    }
  };

  useEffect(() => {
    // const isSiteStaff = pageStates?.staffType === "0";
    // // const hasSiteId = !!filterDetails?.siteId;

    // if (isSiteStaff) return;

    GetAttendance();
  }, [
    pageStates?.staffType,
    pageStates?.currentPage,
    pageStates?.pageSize,
    filterDetails?.siteId,
    filterDetails?.companyId,
    dateFilter,
    pageStates?.searchQuery,
  ]);

  useEffect(() => {
    GetCompanyList();
    getSite();
  }, []);

  const GetAttendance = () => {
    let options = {
      method: "GET",
    };
    const filterData = {
      staffType: pageStates?.staffType,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.activeTab == 1 ? "" : pageStates?.siteId,
      companyId: filterDetails?.companyId,
      months: dateFilter,
      currentPage: pageStates?.currentPage,
      pageSize: pageStates?.pageSize,
    };
    delete filterData?.year;
    delete filterData?.sortByDate;
    const Url =
      apiUrl.get_attendance +
      "?myAttendance=false&from=todayAtt&" +
      MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        setState((pre) => ({
          ...pre,
          attendanceList: res?.data?.attendance,
        }));
        setPageStates((pre) => ({
          ...pre,
          totalPages: res?.data?.pageInfo?.totalPages,
          count: res?.data?.pageInfo?.total,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const PageSizeChangeHandler = (e) => {
    const newSize = parseInt(e.target.value, 10);
    setPageStates((prev) => ({
      ...prev,
      pageSize: newSize,
      currentPage: 1,
    }));
  };

  const GetCompanyList = (inputValue = null) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };

      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const getSite = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl?.get_user_site +
        `?pageSize=100` +
        (companyId ? `&companyId=${companyId}` : "") +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item.site?.id,
              label: item?.site?.name,
            }));

            const siteId = response.data?.site?.some(
              (item) => item.site?.id == filterDetails?.siteId,
            );
            setPageStates((prev) => ({
              ...prev,
              ...(siteId ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const singleDateChangeHandler = (date) => {
    if (!date || !moment(date).isValid()) return;

    const selectedStartDate = moment(date)
      .startOf("month")
      .format("YYYY-MM-DD");
    const selectedEndDate = moment(date).endOf("month").format("YYYY-MM-DD");
    dispatch(updateDateFilter([selectedStartDate, selectedEndDate]));
  };

  const handleData = (data, type = null) => {
    setPageStates((pre) => ({
      ...pre,
      currentPage: 1,
      ...(type == "site" && { siteId: data?.site }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId }),
      }),
    );
    if (pageStates?.activeTab === 2 && type == "companyId") {
      getSite(data?.companyId);
    }
  };

  const sortListSite = {
    isShow: true,
    ...(pageStates.activeTab === 2 && { site: pageStates?.siteList }),
    companyList: pageStates?.companyList,
    resetState: pageStates.activeTab,
  };

  const sortListOffice = {
    isShow: true,
    site: pageStates?.siteList,
    companyList: pageStates?.companyList,
    resetState: pageStates.activeTab,
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
        currentPage: 1,
      }));
    }, 500);
  };

  const getLeaveCount = (data) => {
    const option = {
      method: "GET",
    };
    const url =
      apiUrl.get_leave_count + `?type=${data?.type}&userId=${data?.userId}`;
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          listType: res?.data,
          userName: data?.userName,
          userId: data?.userId,
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handleChangeAttendance = (newStatus, userId, userName, date) => {
    if (newStatus !== 3) {
      const submitData = {
        userId,
        markingAttendance: true,
        status: newStatus,
        date,
      };
      setState((prev) => ({
        ...prev,
        isAttendanceMarkLoading: true,
      }));
      callApi(apiUrl.mark_attendance, {
        method: "POST",
        data: submitData,
      }).then((res) => {
        setState((prev) => ({
          ...prev,
          isAttendanceMarkLoading: false,
        }));
        if (res?.status === true) {
          setState((prev) => ({
            ...prev,
            attendanceList: prev.attendanceList.map((user) => {
              if (user.id !== userId) return user;

              const attendances = user.attendances || [];

              const isDateExist = attendances.some(
                (att) => att.checkInTime?.split("T")[0] === date,
              );

              return {
                ...user,
                attendances: isDateExist
                  ? attendances.map((att) =>
                    att.checkInTime?.split("T")[0] === date
                      ? { ...att, status: newStatus }
                      : att,
                  )
                  : [
                    ...attendances,
                    {
                      checkInTime: `${date}T00:01:00.000Z`,
                      status: newStatus,
                    },
                  ],
              };
            }),
          }));
          toast.success("Attendance Updated");
          // GetAttendance();
        } else {
          toast.error(res?.message);
        }
      });
    } else {
      setSelectedLeaveDate(date);
      const data = {
        userName,
        userId,
        type: "remaining",
      };
      getLeaveCount(data);
      toggleModal();
    }
  };

  // console.log(state.attendanceList);

  const isBulkAttDisabled =
    (userDetails?.department?.name !== "HRM" &&
      !(
        userDetails?.department?.name === "Solar / Wind" &&
        userDetails?.designation?.name === "Plant Head"
      )) ||
    state?.isAttendanceMarkLoading;

  const ActionData = [
    {
      label: "Mark Bulk Att.",
      className: "btn btn-link p-0",
      icon: <PlusIcon />,
      title: "Mark Bulk Attendance",
      isShow: true,
      clickHandler: () => { },
    },
  ];


  // console.log("sortBySingledate=========>", pageStates?.sortByDate);

  return (
    <>
      {pageStates?.tableLoader && <BgBlurLoader />}
      {state.isAttendanceMarkLoading && <FullPageLoaderMarkAtt />}
      <div className="content">
        <MainHeading
          title={"Manage Bulk Attendance"}
          showDefaultDate={true}
          singleDateChangeHandler={singleDateChangeHandler}
          pickerType="month"
          pageState={pageStates}
        />
        {checkUserAccess(userDetails).isUserAccess ? (
          <>
            <Nav tabs className="nav nav-tabs border-0 mb-4">
              <NavItem className="nav-item">
                <NavLink
                  className={
                    pageStates?.activeTab === 1
                      ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                      : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab(1)}
                >
                  Office Staff Attendance
                </NavLink>
              </NavItem>
              <NavItem className="nav-item ">
                <NavLink
                  className={
                    pageStates?.activeTab === 2
                      ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                      : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab(2)}
                >
                  Site Staff Attendance
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={pageStates?.activeTab}>
              <TabPane tabId={1}>
                <Fade in={pageStates?.activeTab === 1} timeout={200}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <FilterComponent
                        handleSearch={handleSearchChange}
                        searchPlaceHolder={"Search by Employee"}
                        filterArray={sortListSite}
                        pageState={pageStates}
                        handleData={handleData}
                        sortHandler={handleData}
                        pageStates={pageStates}
                        getCompany={GetCompanyList}
                      />
                      <AttendanceTable
                        attendanceList={state?.attendanceList}
                        dateFilter={dateFilter}
                        userDetails={{
                          ...userDetails,
                          isAttendanceMarkLoading:
                            state.isAttendanceMarkLoading,
                        }}
                        handleChangeAttendance={handleChangeAttendance}
                        currentPage={pageStates?.currentPage}
                        totalPages={pageStates?.totalPages}
                        handlePageChange={PageChangeHandler}
                        pageSize={pageStates?.pageSize}
                        handlePageSizeChange={PageSizeChangeHandler}
                      // ActionData={ActionData}
                      />
                    </div>
                  </div>
                </Fade>
              </TabPane>
              <TabPane tabId={2}>
                <Fade in={pageStates?.activeTab === 2} timeout={200}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <FilterComponent
                        handleSearch={handleSearchChange}
                        searchPlaceHolder={"Search by Employee"}
                        filterArray={sortListSite}
                        leaveList={state?.siteList}
                        pageState={pageStates}
                        handleData={handleData}
                        sortHandler={handleData}
                        pageStates={pageStates}
                        getCompany={GetCompanyList}
                        getSite={getSite}
                      />
                      <AttendanceTable
                        attendanceList={state?.attendanceList}
                        dateFilter={dateFilter}
                        userDetails={{
                          ...userDetails,
                          isAttendanceMarkLoading:
                            state.isAttendanceMarkLoading,
                        }}
                        handleChangeAttendance={handleChangeAttendance}
                        currentPage={pageStates?.currentPage}
                        totalPages={pageStates?.totalPages}
                        handlePageChange={PageChangeHandler}
                        pageSize={pageStates?.pageSize}
                        handlePageSizeChange={PageSizeChangeHandler}
                      // ActionData={ActionData}
                      />
                    </div>
                  </div>
                </Fade>
              </TabPane>
            </TabContent>
          </>
        ) : (
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent
                handleSearch={handleSearchChange}
                searchPlaceHolder={"Search by Employee"}
                filterArray={sortListOffice}
                pageState={pageStates}
                handleData={handleData}
                sortHandler={handleData}
                pageStates={pageStates}
                getCompany={GetCompanyList}
                getSite={getSite}
              />
              <AttendanceTable
                attendanceList={state?.attendanceList}
                dateFilter={dateFilter}
                userDetails={{
                  ...userDetails,
                  isAttendanceMarkLoading: state.isAttendanceMarkLoading,
                }}
                handleChangeAttendance={handleChangeAttendance}
                currentPage={pageStates?.currentPage}
                totalPages={pageStates?.totalPages}
                handlePageChange={PageChangeHandler}
                pageSize={pageStates?.pageSize}
                handlePageSizeChange={PageSizeChangeHandler}
              // ActionData={ActionData}
              />
            </div>
          </div>
        )}
      </div>

      <AddLeaveModal
        isOpen={modal}
        onClose={toggleModal}
        EditLeaveData={null}
        teamDate={selectedLeaveDate}
        Type={"leaveForUser"}
        state={{ ...pageStates, sortBySingleDate: selectedLeaveDate }}
        getAttendance={GetAttendance}
        fromBulkAtt={true}
        markAttendance={true}
      />
    </>
  );
}
